<template>

  <vuestic-navbar>
    <header-selector slot="selector" :isOpen.sync="valueProxy"/>
    <span slot="logo" class="i-vuestic">Kagoshima PT</span>
    <span slot="center">
    </span>
    <!--
    <message-dropdown/>
    <notification-dropdown/>
    <language-dropdown/>
    <profile-dropdown>
      設定
    </profile-dropdown>
    -->
  </vuestic-navbar>

</template>


<script>
  import VuesticNavbar from '../../../vuestic-theme/vuestic-components/vuestic-navbar/VuesticNavbar'
  import HeaderSelector from './components/HeaderSelector'
  import LanguageDropdown from './components/dropdowns/LanguageDropdown'
  import ProfileDropdown from './components/dropdowns/ProfileDropdown'
  import NotificationDropdown from './components/dropdowns/NotificationDropdown'
  import MessageDropdown from './components/dropdowns/MessageDropdown'

//  import ax from '../../../axios/ax'

  export default {
    name: 'app-navbar',

    components: {
      VuesticNavbar,
      HeaderSelector,
      MessageDropdown,
      NotificationDropdown,
      LanguageDropdown,
      ProfileDropdown
    },
    props: {
      isOpen: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      valueProxy: {
        get () {
          return this.isOpen
        },
        set (opened) {
          this.$emit('toggle-menu', opened)
        },
      },
    },
    beforeMount: function () {
      /*
      if (!this.$jwt.hasToken()) {
        this.$router.push({ name: 'login' })
      }
      ax.loginCheck(this.$jwt.getToken(), this)
      */
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/admin/app-navbar/AppNavbar.vue